import { render, staticRenderFns } from "./FormQuestionMatrixType.vue?vue&type=template&id=557a2134"
import script from "./FormQuestionMatrixType.vue?vue&type=script&lang=js"
export * from "./FormQuestionMatrixType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557a2134')) {
      api.createRecord('557a2134', component.options)
    } else {
      api.reload('557a2134', component.options)
    }
    module.hot.accept("./FormQuestionMatrixType.vue?vue&type=template&id=557a2134", function () {
      api.rerender('557a2134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionMatrixType.vue"
export default component.exports